import script from "./AnnahmeCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnahmeCheck.vue?vue&type=script&setup=true&lang=js"

import "./AnnahmeCheck.vue?vue&type=style&index=0&id=5349c066&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5349c066"]])

export default __exports__